import { useQuery } from '@tanstack/react-query'
import { apiBase } from '~utils/base-url'
import { useFetch } from '~utils/fetch-request'

export function useGetTabList({
  vesselId,
  type = 'operations',
}: {
  vesselId: string | null | undefined
  type?: 'operations' | 'financials'
}) {
  const options = useGetTabListOptions()
  return useQuery(options({ vesselId, type }))
}

export function useGetTabListOptions() {
  const fetchRequest = useFetch<{ name: string; path: string }[]>()

  return ({
    vesselId,
    type = 'operations',
  }: {
    vesselId: string | null | undefined
    type?: 'operations' | 'financials'
  }) => {
    const url = `/tabs/${vesselId}`
    return {
      queryKey: [url, type],
      queryFn: () => fetchRequest(`${apiBase()}${url}?type=${type}`),
      staleTime: Infinity,
      enabled: !!vesselId,
    }
  }
}
